import { isAngleLine, isHorizontalLine, isVerticalLine } from './isLineType';
import { round } from './round';
import { Line } from './types';

export const arePerpendicular = (line1: Line, line2: Line) =>
  (isHorizontalLine(line1) && isVerticalLine(line2)) ||
  (isVerticalLine(line1) && isHorizontalLine(line2)) ||
  (isAngleLine(line1) && isAngleLine(line2) && round(line1.m) === round(line2.m * -1));
